import instanceJWT from "./apiJwt";
import type { EplexAccountInfo } from "../models/eplex/AccountInfo";

/**
 * Метод Eplex API, а не бэка ЛК: путь с префиксом `eplex/` идёт через прозрачный
 * прокси. Бэк ЛК оборачивает ответ в свой конверт, поэтому полезные поля лежат
 * на третьем уровне: `data.data.data`.
 */
const ENDPOINT = "eplex/auth/info";

/** Флаг из PHP-прослойки приходит и булевым, и числом 0/1. */
type FlagLike = boolean | number | null;

interface AccountInfoEnvelope {
  status?: boolean;
  data?: {
    status?: string;
    error_code?: number;
    data?: {
      id?: number | null;
      client_id?: number | null;
      client_name?: string | null;
      name?: string | null;
      email?: string | null;
      phone?: string | null;
      billing_type?: number | null;
      trial?: FlagLike;
      is_onboarding?: FlagLike;
    };
  };
}

function toBool(value: FlagLike | undefined): boolean {
  return value === true || value === 1;
}

export async function fetchEplexAccountInfo(): Promise<EplexAccountInfo> {
  const response = await instanceJWT.get<AccountInfoEnvelope>(ENDPOINT);
  const data = response.data?.data?.data ?? {};

  return {
    id: data.id ?? null,
    clientId: data.client_id ?? null,
    clientName: data.client_name ?? "",
    name: data.name ?? "",
    email: data.email ?? null,
    phone: data.phone ?? null,
    // Отсутствие поля — лицензионная схема: так ведут себя учётки, которых
    // биллинг ещё не коснулся
    billingType: data.billing_type ?? 0,
    trial: toBool(data.trial),
    isOnboarding: toBool(data.is_onboarding),
  };
}
